<template>
  <nav class="nav-bar">
    <!-- Standard Nav Links -->
    <router-link to="/" class="nav-link" exact>Home</router-link>
    <router-link to="/about" class="nav-link">About</router-link>

    <!-- Dev Routes as Nav Pills -->
    <div class="dev-nav">
      <span class="dev-nav-label">Dev Tools</span>
      <router-link
        v-for="route in devRoutes"
        :key="route.value"
        :to="'/' + route.value"
        class="dev-link"
      >
        🧪 {{ route.name }}
      </router-link>
    </div>
  </nav>

  <div id="main-content">
    <router-view />
  </div>
</template>

<script setup>
const devRoutes = [
  { name: "Spaces Development", value: "spaces-development" },
  { name: "Noa: Management App", value: "noa-management-app" },
];
</script>

<style scoped>
/* General Layout */
.nav-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 24px;
  border-bottom: 1px solid #e0e0e0;
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 10;
  flex-wrap: wrap;
}

/* Navigation Links */
.nav-link {
  color: #333;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;
}

.nav-link:hover {
  color: #007bff;
}

.router-link-exact-active {
  font-weight: bold;
  border-bottom: 2px solid #42b983;
  padding-bottom: 2px;
  color: #42b983;
}

/* Dev Links */
.dev-nav {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  background-color: #f5f5f5;
  padding: 6px 10px;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.dev-nav-label {
  font-size: 12px;
  color: #888;
  margin-right: 8px;
}

.dev-link {
  background-color: #fff;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 13px;
  color: #555;
  text-decoration: none;
  border: 1px solid #ddd;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.dev-link:hover {
  background-color: #eef6ff;
  color: #007bff;
}

.dev-link.router-link-exact-active {
  background-color: #e6f4ea;
  border-color: #b8e2ca;
  color: #2a7a47;
  font-weight: 600;
}

/* Main Content */
#main-content {
  padding: 32px;
  max-width: 1200px;
  margin: 0 auto;
}
</style>
